"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = (0, _runtime.IconWrapper)('symbol_cross_two', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#757575',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#757575'
    }
  }, [h("path", {
    "attrs": {
      "d": "M3 13L13 3M3 3L13 13",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })])]);
});
exports.default = _default;